import { createAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import { getUserProfileService, sendOtpService, userLoginService, verifyOtpService } from 'services/auth.service';

export const logoutUser = createAction(`LOGOUT_USER`);

export const loginUser = createAsyncThunk(
  `LOGIN`,
  async (body, { rejectWithValue }) => {
    try {
      const response = await userLoginService(body);
      return response;
    } catch (error) {
      throw rejectWithValue(error);
    }
  }
);

export const sendOtp = createAsyncThunk('RESEND_OTP', async (_, { rejectWithValue }) => {
  try {    
    const response = await sendOtpService();
    return response;
  } catch (error) {
    throw rejectWithValue(error);
  }
});

export const verifyOtp = createAsyncThunk(
  `VERIFY_OTP`,
  async (body, { rejectWithValue}) => {
    try {      
      const response = await verifyOtpService(body);
      return response;
    } catch (error) {
      throw rejectWithValue(error);
    }
  }
);

export const getUserProfile = createAsyncThunk(
  `PROFILE`,
  async (_, { rejectWithValue }) => {
    try {
      const response = await getUserProfileService();
      return response;
    } catch (error) {
      throw rejectWithValue(error);
    }
  }
);

const initialState = {
  isAuthenticated: false,
  user: null,
  isSendingOtp: false,
  isOtpSent: true
};

export const authSlice = createSlice({
  name: 'userData',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // for login API
    builder.addCase(loginUser.fulfilled, (state, { payload }) => {
      state.isAuthenticated = true;
      localStorage.clear();
      const { accessToken, refreshToken, ...restParams } = payload?.data?.data;
      state.user = {
        email: restParams?.email,
        firstName: restParams?.firstName,
        lastName: restParams?.lastName,
        maskedPhoneNumber: restParams?.maskedPhoneNumber,
      };
      localStorage.setItem('access_token_temp', accessToken)
      localStorage.setItem('refresh_token', refreshToken);
      payload?.data?.message && toast.success(
        payload?.data?.message 
      );
    });
    builder.addCase(loginUser.rejected, (state, { payload }) => {
      state.user = null;
      state.isAuthenticated = false;
      throw payload;
    });

    // for verify OTP API
    builder.addCase(verifyOtp.pending, (state) => {
      state.isAuthenticated = false;
    })
    builder.addCase(verifyOtp.fulfilled, (state, { payload }) => {
      state.isAuthenticated = true;
      const { accessToken, refreshToken, ...restParams } = payload?.data?.data;
      state.user = {
        email: restParams?.email,
        firstName: restParams?.firstName,
        lastName: restParams?.lastName,
        maskedPhoneNumber: restParams?.maskedPhoneNumber,
        role: restParams?.role,
      };
      localStorage.removeItem('access_token_temp');
      localStorage.setItem('access_token', accessToken)
      localStorage.setItem('refresh_token', refreshToken);
      payload?.data?.message && toast.success(
        payload?.data?.message
      );
    }).addCase(verifyOtp.rejected, (state, { payload }) => {
      state.isAuthenticated = false;
      toast.error(
        payload?.response?.data?.message ?? 'Something went wrong!'
      );
      throw payload
    });

    // for send OTP API
    
    builder
      .addCase(sendOtp.pending, (state) => {
        state.isSendingOtp = true;
        state.isOtpSent = false;
      })
      .addCase(sendOtp.fulfilled, (state, { payload }) => {
        state.isSendingOtp = false;
        state.isOtpSent = true;
        toast.success(
          payload?.data?.message ?? 'Something went wrong!'
        );
      }).addCase(sendOtp.rejected, (state, { payload }) => {
        state.isSendingOtp = false;
        state.isOtpSent = false;
        toast.error(
          payload?.response?.data?.message ?? 'Something went wrong!'
        );
      });

    // for user profile API
    builder.addCase(getUserProfile.fulfilled, (state, { payload }) => {
      state.isAuthenticated = true;
      state.user = payload?.data?.data?.user;
    });
    builder.addCase(getUserProfile.rejected, (state, { payload }) => {
      state.user = null;
      state.isAuthenticated = false;
      throw payload;
    });

    builder.addCase(logoutUser, (state, action) => {
      state.user = null;
      state.isAuthenticated = false;
      localStorage.clear();
    });
  },
});

export default authSlice.reducer;
